import React, { Component } from 'react';

import { enableContext, disableContext } from './LegacyShortcutsBridge';

/**
 * shortcutContext('global') or shortcutContext(['global', 'viewcontent'])
 * @param context
 * @returns {Function}
 */
function shortcutContext(context) {
	return (BaseComponent) => {
		class ShortcutContextComponent extends Component {
			componentDidMount() {
				enableContext(context);
			}
			componentWillUnmount() {
				disableContext(context);
			}
			render() {
				return <BaseComponent {...this.props} />;
			}
		}

		ShortcutContextComponent.displayName = `ShortcutContextComponent(${
			BaseComponent.displayName || BaseComponent.name
		})`;

		return ShortcutContextComponent;
	};
}

export default shortcutContext;
